import { ChangeDetectionStrategy, Component } from '@angular/core';
import { UiComponent } from '@df/ui/ui.component';
import { RatioOptions } from '@df/ui/atomic/atomic-options';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { defaultImage } from '../../icms.config';
import { DfModuleImageModule } from '@df/module-image/df-module-image.module';
import { HrefComponent } from '@df/ui/common/href/href.component';

export namespace NCmsImage {
    export const componentId = 'image';

    export interface IComponentData extends NICmsContentComponent.IData {
        roundedImage: boolean;
        image: string;
        ratio: string;
        link?: string;
    }
}

@ICmsComponent<CmsImageComponent>({
    id: NCmsImage.componentId,
    name: 'Image',
    tags: ['image', 'big', 'banner'],
    isAdvanced: true,
    fields: [
        <NICmsContentField.IToggleField>{
            key: 'roundedImage',
            type: NICmsContentField.EFieldType.toggle,
            title: 'Rounded image corners',
            labels: { true: 'Yes', false: 'No' },
            default: true
        },
        <NICmsContentField.IChoiceField>{
            key: 'ratio',
            type: NICmsContentField.EFieldType.choice,
            title: 'Aspect ratio',
            options: RatioOptions,
            description: 'Proportions width x height',
            default: 'ratio-2-1',
            required: true
        },
        {
            key: 'image',
            type: NICmsContentField.EFieldType.image,
            title: 'Image',
            default: defaultImage,
            required: true
        },
        {
            key: 'link',
            type: NICmsContentField.EFieldType.text,
            title: 'Link'
        }
    ],
    priority: 30
})
@Component({
    standalone: true,
    imports: [DfModuleImageModule, HrefComponent],
    selector: 'cms-image',
    templateUrl: './cms-image.html',
    styleUrls: ['./cms-image.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CmsImageComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'component'
    })
    component?: NCmsImage.IComponentData;

    get isRoundedImage() {
        return this.component?.roundedImage === undefined ? true : this.component?.roundedImage;
    }
}
